var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":_vm.getFeedbackVariant,"dismissible":"","fade":"","show":_vm.showMessage},on:{"dismissed":_vm.dimissFeedbackMessage}},[_vm._v(_vm._s(_vm.getFeedbackMessage))])}
var staticRenderFns = []

export { render, staticRenderFns }